<template>
  <div class="gallery-container w-100">
    <slot name="before-container" :images="this.value || this.modelValue" />
    <div :class="['list-preview-items position-relative', selected.background, selected.background != '' ? 'background' : '']">
      <div class="image-preview-wrapper">
        <slot name="before-wrapper" :images="finalValue" :image="mainPreview" :group="selected.group" :index="selected.index" />
        <div v-if="config?.fullScreen" class="font-icon-wrapper" @click="fullScreenPreview">
          <i class="ti ti-maximize"> </i>
        </div>
        <div v-if="$_.isString(mainPreview) && !Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(mainPreview))" class="download-btn">
          <div @click="downloadFile(mainObjectPreview)"><span></span><i class="ti ti-cloud-down"></i></div>
        </div>
        <div class="image-preview-inner position-absolute" ref="imagePreview">
          <div class="image-preview" ref="imageWrapper">
            <slot name="before-preview" :image="mainPreview" />
            <div :class="`img full`" @mousedown.stop.prevent="handleDrag" ref="image">
              <Image :src="srcImage(mainPreview, 'full')" />
            </div>
            <slot name="after-preview" :image="mainPreview" />
          </div>
        </div>
        <slot name="after-wrapper" :images="finalValue" :image="mainPreview" :group="selected.group" :index="selected.index" />
      </div>
    </div>
    <div class="footer-wrapper">
      <ul v-if="config?.background" class="list-background mb-2 noise">
        <li v-for="(label, color) in backgroundColors" :key="color">
          <span :class="`${color} background has-tip`" :data-title="label" :data-color="color" @click="chooseBackground(color)"></span>
        </li>
      </ul>
      <slot name="before-footer-container" :images="this.value || this.modelValue" />
      <div v-if="config?.thumbnail" class="position-relative list-thumbnail-wrapper">
        <div class="toggle-collapse" @click.stop.prevent="selected.collapse = !selected.collapse">
          <i :class="`ti ti-chevron-${!selected.collapse ? 'down' : 'up'}`"></i>
        </div>
        <div v-for="[key, group] in finalGroups" :key="key" v-show="!selected.collapse || group.visible" class="w-100 position-relative group-thumbnail-row">
          <label v-if="config?.showLabel && finalValue[key] && finalValue[key].length > 0" class="group-label">{{ group.label }}</label>
          <ThumbnailPreview :data-type="key" :value="finalValue[key]" :args="{ config, group }" :editable="config?.editable ?? group?.editable" @change="handleRemoveThumbnail($event, key)" @selected="handleSelectedThumbnail($event, key)" class="list-thumbnail p-2">
            <template v-for="slotName in thumbnailSlots" v-slot:[slotName]="slotProps">
              <slot :name="`thumbnail-${slotName}`" v-bind="slotProps ?? {}" />
            </template>
          </ThumbnailPreview>
        </div>
      </div>
      <slot name="after-footer-container" :images="this.value || this.modelValue" />
    </div>
    <slot name="after-container" :images="this.value || this.modelValue" />
  </div>
</template>

<script>
import Md5 from 'crypto-js/md5'
import defaultPreview from '@/../assets/imgs/no-preview.jpg'
import defaultThumbnail from '@/../assets/imgs/no-thumbnail.jpg'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
let images = new Map()
export default {
  components: {
    ThumbnailPreview
  },
  data() {
    return {
      selected: {
        group: null,
        index: null,
        background: '',
        collapse: false
      },
      scale: 1,
      client: {
        x: 0,
        y: 0
      },
      startPoint: {
        x: 0,
        y: 0
      },
      backgroundColors: {
        'no-color': 'No Color',
        'black': 'Black',
        'white': 'White',
        'drak-grey': 'Drak Grey',
        'sport-grey': 'Sport Grey',
        'red': 'Red',
        'navy': 'Navy',
        'royal-blue': 'Royal Blue',
        'pale-pink': 'Pale Pink',
        'hot-pink': 'Hot Pink',
        'kelly': 'Kelly',
        'purple': 'Purple',
        'yellow': 'Yellow'
      }
    }
  },
  mounted() {
    window.addEventListener('wheel', this.scaleImage)
  },
  unmounted() {
    window.removeEventListener('wheel', this.scaleImage)
  },
  computed: {
    thumbnailSlots() {
      return Object.entries(this.$slots).reduce((result, [key]) => {
        if (key.startsWith('thumbnail-')) {
          result.push(key.replace('thumbnail-', ''))
        }
        return result
      }, [])
    },
    finalGroups() {
      return Object.entries(
        Object.assign(
          {
            default: {
              label: 'Default',
              priority: 10
            }
          },
          this.groups
        )
      ).sort(([, a], [, b]) => (b.priority || 10) - (a.priority || 10))
    },
    finalValue() {
      return Object.entries(this.value || this.modelValue).reduce((result, [key, current]) => {
        if (!result?.[current?.group || 'default']) {
          result[current?.group || 'default'] = []
        }
        if (_.isString(current)) {
          result[current?.group || 'default'].push({
            items: [current],
            _index: key
          })
        } else {
          result[current?.group || 'default'].push(
            Object.assign(
              {
                _index: key
              },
              current
            )
          )
        }
        return result
      }, {})
    },
    mainObjectPreview() {
      let images = this.finalValue?.[this.selected.group || this?.config?.default?.selected?.group || 'default']?.[this.selected.index || this?.config?.default?.selected?.index || 0]
      return images
    },
    mainPreview() {
      return this.getImagePreview(this?.mainObjectPreview)
    }
  },
  methods: {
    getSlotName(slotName) {
      return slotName.replace('thumbnail-', '')
    },
    getImagePreview(images) {
      if (_.isString(images) || images instanceof File || images instanceof Blob) {
        return images
      } else if (_.isString(images?.items) || images?.items instanceof File || images?.items instanceof Blob) {
        return images?.items
      } else if (_.isString(images?.items?.[0]) || images?.items?.[0] instanceof File || images?.items?.[0] instanceof Blob) {
        return images.items[0]
      }
      return defaultThumbnail
    },
    handleRemoveThumbnail(e) {
      let value = this.value || this.modelValue
      let item = value.splice(e?.deleted?._index, 1)
      this.$emit('changeValue', value, {
        action: 'delete',
        item: item.shift()
      })
      this.$emit('update:modelValue', value)
    },
    srcImage(image, size) {
      if (image instanceof File || image instanceof Blob) {
        if (image.type.indexOf('image') != -1) {
          let hash = Md5(`${image.lastModified}|${image.size}|${image.type}|${image.webkitRelativePath}|${image.name}`).toString()
          if (!images.has(hash)) {
            images.set(hash, URL.createObjectURL(image))
          }
          return images.get(hash)
        }
      } else if (String(image).length > 0) {
        if (Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(image))) {
          return this.$util.addQueryParam(String(image), { size })
        }
      }
      return defaultPreview
    },
    scaleImage(e) {
      if (!this.$refs.imagePreview.matches(':hover')) return false
      if (e.deltaY > 0) {
        this.scale -= 0.35
      } else {
        this.scale += 0.35
      }
      this.scale = Math.max(this.scale, 1)
      this.$refs.image.style.transform = `scale3d(${this.scale}, ${this.scale}, 1)`
      if (e.deltaY > 0) {
        let containerPosition = this.$refs.imagePreview.getBoundingClientRect()
        let imagePosition = this.$refs.image.getBoundingClientRect()
        let limit = {
          x: Math.round((imagePosition.width - containerPosition.width) / 2),
          y: Math.round((imagePosition.height - containerPosition.height) / 2)
        }
        if (imagePosition.left > containerPosition.left || imagePosition.right < containerPosition.right || imagePosition.top > containerPosition.top || imagePosition.botton < containerPosition.botton) {
          this.client.x = Math.max(-limit.x, Math.min(limit.x, this.client.x))
          this.client.y = Math.max(-limit.y, Math.min(limit.y, this.client.y))
          this.$refs.imageWrapper.style.transform = `translate3d(${this.client.x}px, ${this.client.y}px, 0)`
        }
      }
    },
    async downloadFile(objectImage) {
      if (this.$el.querySelector('.downloading')) return false
      this.$util.downloadFile({
        url: this.getImagePreview(objectImage),
        name: objectImage?.name || null,
        callback: {
          start: () => {
            this.$el.querySelector('.download-btn').classList.add('downloading')
          },
          progressed: (percent) => {
            this.$el.querySelector('span').innerHTML = `${percent}%`
          },
          finally: () => {
            this.$el.querySelector('.download-btn').classList.remove('downloading')
            this.$el.querySelector('span').innerHTML = ''
          }
        }
      })
    },
    handleDrag(e) {
      this.handlerStartDrag(e)
      document.addEventListener('mousemove', this.handlerDraging)
      document.addEventListener('mouseup', this.handlerStopDrag)
    },
    handlerStartDrag(e) {
      this.startPoint.x = e.clientX - this.client.x
      this.startPoint.y = e.clientY - this.client.y
    },
    handlerDraging(e) {
      let containerPosition = this.$refs.imagePreview.getBoundingClientRect()
      let imagePosition = this.$refs.image.getBoundingClientRect()
      let limit = {
        x: Math.round((imagePosition.width - containerPosition.width) / 2),
        y: Math.round((imagePosition.height - containerPosition.height) / 2)
      }
      this.client.x = Math.max(-limit.x, Math.min(limit.x, e.clientX - this.startPoint.x))
      this.client.y = Math.max(-limit.y, Math.min(limit.y, e.clientY - this.startPoint.y))
      this.$refs.imageWrapper.style.transform = `translate3d(${this.client.x}px, ${this.client.y}px, 0)`
    },
    handlerStopDrag() {
      document.removeEventListener('mousemove', this.handlerDraging)
      document.removeEventListener('mouseup', this.handlerStopDrag)
    },
    handleSelectedThumbnail(index, group) {
      this.selected.group = group
      this.selected.index = index
      this.$el.querySelectorAll(`.thumbnail-preview-container .selected`).forEach((element) => {
        element.classList.remove('selected')
      })
      this.$el.querySelector(`.thumbnail-preview-container[data-type="${group}"] .thumbnail-preview-wrapper[data-index="${index}"]`).classList.add('selected')
    },
    fullScreenPreview() {
      this.$emitter.emit('SubModal', {
        name: 'full-screen-image-preview',
        data: {
          files: [this.srcImage(this.mainPreview)]
        }
      })
    },
    chooseBackground(color) {
      this.selected.background = color
    }
  },
  props: {
    value: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    modelValue: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    groups: {
      type: Object,
      default() {
        return {}
      }
    },
    config: Object
  },
  watch: {
    images() {
      this.scale = 1
      this.client = {
        x: 0,
        y: 0
      }
      this.startPoint = {
        x: 0,
        y: 0
      }
    }
  }
}
</script>

<style lang="scss">
.gallery-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  position: relative;
  background: #fff;
  overflow: hidden;
  .list-preview-items {
    flex: 1;
    .image-preview-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      // height: 100%;
    }
    .font-icon-wrapper {
      display: flex;
      margin: 0;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 999;
      cursor: pointer;
      opacity: 0.3;
      color: #333;
      &:hover {
        opacity: 1;
      }
    }
    &,
    .image-preview-inner,
    .image-preview,
    .img {
      width: 100%;
      height: 100%;
    }
    .image-preview-inner {
      top: 0;
      left: 0;
    }
    img {
      width: 100%;
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
    }
  }
  .footer-wrapper {
    position: relative;
    z-index: 99999;
    bottom: 0;
    width: 100%;
    transition: opacity 0.3s ease-in-out;
    background: #fff;
    .list-background {
      position: absolute;
      display: flex;
      list-style: none;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0;
      margin: 0;
      opacity: 0;
      z-index: 9;
      bottom: 100%;
      left: 50%;
      transform: translate(-50%, 0);
      li {
        padding: 5px;
        span {
          width: 40px;
          height: 40px;
          cursor: pointer;
          display: block;
          border-radius: 50%;
          box-shadow: 0 0 10px #888;
        }
      }
      &:hover {
        opacity: 1;
      }
    }
    .group-thumbnail-row {
      .group-label {
        position: absolute;
        top: 4px;
        left: 4px;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 11px;
        z-index: 10;
        pointer-events: none;
      }
    }
    .thumbnail-preview-container {
      width: 100%;
      border-top: 1px solid #dfdfdf;
      justify-content: center;
      &:empty {
        display: none;
      }
      .thumbnail-preview-wrapper {
        &.selected {
          .thumbnail-preview {
            border: 3px solid #00a6ff;
          }
        }
        .lazy-error {
          background-size: 100%;
        }
      }
    }
    .toggle-collapse {
      position: absolute;
      bottom: 100%;
      right: 20px;
      width: 30px;
      height: 30px;
      z-index: 999999;
      cursor: pointer;
      display: none;
      border: 1px solid #dfdfdf;
      border-bottom: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      padding-bottom: 1px;
      margin-bottom: -1px;
      background: #fff;
      font-size: 25px;
      align-items: center;
      justify-content: center;
    }
  }
  &:hover {
    .toggle-collapse {
      display: flex;
    }
  }

  .background {
    background-image: url('@/../assets/imgs/noise.svg');
    &.no-color {
      background-image: url('@/../assets/imgs/dot.jpg');
    }
    &.black {
      background-color: #000;
    }
    &.white {
      background-color: #fff;
    }
    &.drak-grey {
      background-color: #5d6164;
    }
    &.sport-grey {
      background-color: #acadaf;
    }
    &.red {
      background-color: #b2233f;
    }
    &.navy {
      background-color: #1d3341;
    }
    &.royal-blue {
      background-color: #48689b;
    }
    &.pale-pink {
      background-color: #e3bec6;
    }
    &.hot-pink {
      background-color: #c01b84;
    }
    &.kelly {
      background-color: #1a7d5e;
    }
    &.purple {
      background-color: #45325f;
    }
    &.yellow {
      background-color: #fcbd5c;
    }
  }

  .download-btn {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: 0;
    cursor: pointer;
    opacity: 0.3;
    justify-content: center;
    align-items: center;
    background: #ffffff40;
    z-index: 99;
    div {
      position: relative;
      background: #fff;
      color: #777;
      border-radius: 8px;
      border: 1px solid #ccc;
      padding: 10px 40px;
    }
    &.downloading,
    &:hover {
      opacity: 1;
      div {
        color: #fff;
        background: #3ac47d;
        border-color: #3ac47d;
      }
    }
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 10px;
    }
    i {
      color: inherit;
      display: block;
      font-size: 40px;
    }
    &.downloading {
      div i {
        -webkit-animation: spin 1000ms infinite linear;
        animation: spin 1000ms infinite linear;
        &::before {
          content: '\f226';
        }
      }
    }
    &:hover {
      opacity: 1;
    }
  }
}
</style>
